import React from 'react'
import { getUser } from '../../../Service/UserFactory'
import RestrictedPage from '../../Rbac/RestrictedPage';

const CompanyAdminRoutes = ({ children }) => {

  const user = getUser();

  return [1, 16].includes(user?.roles[0]?.id)
    ? children
    : <RestrictedPage />
}

export default CompanyAdminRoutes